import { ConfigClient, NOTES_URL } from '../config/ConfigClient';

export function getNotes() {
  const route = `${ConfigClient.get(NOTES_URL)}?t=${Date.now()}`;
  return fetch(route);
}
